export default __webpack_public_path__ + "static/media/user.274c0de8.svg";